module.exports = __webpack_public_path__ + "static/media/bg_netizenpledge-FINISH_Empty.ef1c8f4f.png";